module.exports = __webpack_public_path__ + "img/f-bg1.0349cbb2.png";